import { render } from "./PageExportLayoutAdd.vue?vue&type=template&id=337402c5&scoped=true"
import script from "./PageExportLayoutAdd.vue?vue&type=script&lang=js"
export * from "./PageExportLayoutAdd.vue?vue&type=script&lang=js"

import "./PageExportLayoutAdd.vue?vue&type=style&index=0&id=337402c5&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337402c5"]])

export default __exports__